// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as Utils_Form$DvmAdminFrontendFr from "../../utils/Utils_Form.bs.js";
import * as Utils_Input$DvmAdminFrontendFr from "../../utils/Utils_Input.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../context/user/User_Context.bs.js";

function minWidthStyle(minWidth) {
  return {
          minWidth: minWidth + "px"
        };
}

function App_TextFieldFormInput(Props) {
  var validationResult = Props.validationResult;
  var onChangeOpt = Props.onChange;
  var value = Props.value;
  var style = Props.style;
  var disabled = Props.disabled;
  var onBlur = Props.onBlur;
  var fullWidth = Props.fullWidth;
  var multiline = Props.multiline;
  var classes = Props.classes;
  var className = Props.className;
  var label = Props.label;
  var required = Props.required;
  var name = Props.name;
  var autoCompleteOpt = Props.autoComplete;
  var id = Props.id;
  var inputProps = Props.inputProps;
  var InputLabelProps = Props.InputLabelProps;
  var InputProps = Props.InputProps;
  var inputType = Props.inputType;
  var placeholder = Props.placeholder;
  var maxLength = Props.maxLength;
  var helperTextWhenNoError = Props.helperTextWhenNoError;
  var onFocus = Props.onFocus;
  var onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
        
      });
  var autoComplete = autoCompleteOpt !== undefined ? autoCompleteOpt : "off";
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var labelRef = React.useRef(null);
  var match$1 = React.useState(function () {
        return "";
      });
  var setMinWidth = match$1[1];
  var minWidth = match$1[0];
  React.useEffect((function () {
          Curry._1(setMinWidth, (function (param) {
                  return Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(labelRef.current), "", (function (x) {
                                var domrect = x.getBoundingClientRect();
                                return String(domrect.width + 40);
                              }));
                }));
        }), [
        match[0].locale,
        labelRef
      ]);
  var props = Belt_Option.getWithDefault(inputProps, ({}));
  var tmp = {
    style: Belt_Option.mapWithDefault(style, minWidthStyle(minWidth), (function (x) {
            return Object.assign({}, minWidthStyle(minWidth), x);
          })),
    autoComplete: autoComplete,
    onChange: (function ($$event) {
        var newValue = $$event.target.value;
        Curry._1(onChange, Belt_Option.mapWithDefault(inputType, newValue, (function (x) {
                    if (x !== "number") {
                      return newValue;
                    }
                    var regex = /^\d*\.?\d{0,2}$/;
                    if (Belt_Option.isSome(Caml_option.null_to_opt(newValue.match(regex)))) {
                      return newValue;
                    }
                    var num = Belt_Float.fromString(newValue);
                    if (num !== undefined) {
                      return String(Math.floor(num * 100.0) / 100.0);
                    } else {
                      return Belt_Option.getWithDefault(value, "");
                    }
                  })));
      }),
    size: "small",
    value: Belt_Option.getWithDefault(value, ""),
    variant: "filled"
  };
  if (classes !== undefined) {
    tmp.classes = Caml_option.valFromOption(classes);
  }
  if (className !== undefined) {
    tmp.className = className;
  }
  if (disabled !== undefined) {
    tmp.disabled = disabled;
  }
  var tmp$1 = Belt_Option.map(validationResult, Belt_Result.isError);
  if (tmp$1 !== undefined) {
    tmp.error = tmp$1;
  }
  if (fullWidth !== undefined) {
    tmp.fullWidth = fullWidth;
  }
  var tmp$2 = Belt_Option.mapWithDefault(Utils_Form$DvmAdminFrontendFr.getErrorMessage(intl, validationResult), Belt_Option.mapWithDefault(helperTextWhenNoError, undefined, (function (x) {
              return Caml_option.some(intl.formatMessage(x));
            })), (function (x) {
          return Caml_option.some(x);
        }));
  if (tmp$2 !== undefined) {
    tmp.helperText = Caml_option.valFromOption(tmp$2);
  }
  if (id !== undefined) {
    tmp.id = id;
  }
  if (InputLabelProps !== undefined) {
    tmp.InputLabelProps = Caml_option.valFromOption(InputLabelProps);
  }
  var tmp$3 = (Belt_Option.forEach(maxLength, (function (max) {
            props.maxLength = max;
          })), Caml_option.some(props));
  if (tmp$3 !== undefined) {
    tmp.inputProps = Caml_option.valFromOption(tmp$3);
  }
  if (InputProps !== undefined) {
    tmp.InputProps = Caml_option.valFromOption(InputProps);
  }
  var tmp$4 = Belt_Option.map(label, (function (label) {
          if (required !== undefined && required) {
            return Utils_Input$DvmAdminFrontendFr.requiredLabel(intl, label);
          } else {
            return intl.formatMessage(label);
          }
        }));
  if (tmp$4 !== undefined) {
    tmp.label = Caml_option.valFromOption(tmp$4);
  }
  if (multiline !== undefined) {
    tmp.multiline = multiline;
  }
  if (name !== undefined) {
    tmp.name = name;
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (placeholder !== undefined) {
    tmp.placeholder = placeholder;
  }
  var tmp$5 = Belt_Option.map(required, Utils_Input$DvmAdminFrontendFr.isHtmlRequired);
  if (tmp$5 !== undefined) {
    tmp.required = tmp$5;
  }
  var tmp$6 = Belt_Option.map(inputType, (function (inputType) {
          return inputType;
        }));
  if (tmp$6 !== undefined) {
    tmp.type = tmp$6;
  }
  return React.createElement(React.Fragment, undefined, React.createElement(Core.InputLabel, {
                  style: {
                    position: "absolute",
                    visibility: "hidden",
                    whiteSpace: "nowrap"
                  },
                  children: Belt_Option.mapWithDefault(label, null, (function (label) {
                          if (required !== undefined && required) {
                            return Utils_Input$DvmAdminFrontendFr.requiredLabel(intl, label);
                          } else {
                            return intl.formatMessage(label);
                          }
                        })),
                  htmlFor: "",
                  ref: labelRef
                }), React.createElement(Core.TextField, tmp));
}

var make = App_TextFieldFormInput;

export {
  minWidthStyle ,
  make ,
}
/* react Not a pure module */
